// src/breadcrumbMap.js
const breadcrumbMap = {
  "/": ["Dashboard"],

};

export default breadcrumbMap;
